// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-flow: column;\n}", ""]);
// Exports
module.exports = exports;
